// ============================================
// storeFetch.js — fetch al Store API con la sesión de la clienta
//
// El carrito y el checkout deben viajar autenticados cuando hay sesión: así
// Medusa sabe quién es la clienta (precio socia, mínimo de distribuidora) sin
// depender del correo que se escriba en el checkout.
// Si el token expiró (401), se reintenta una vez como invitada.
// ============================================
import { MEDUSA_API_URL, MEDUSA_API_KEY } from './config';

const getCustomerToken = () => {
  try {
    return localStorage.getItem('medusa_token');
  } catch {
    return null;
  }
};

export async function storeFetch(endpoint, options = {}) {
  const token = getCustomerToken();
  const doFetch = (withAuth) =>
    fetch(`${MEDUSA_API_URL}${endpoint}`, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        'x-publishable-api-key': MEDUSA_API_KEY,
        ...(withAuth && token ? { Authorization: `Bearer ${token}` } : {}),
        ...options.headers,
      },
    });

  let response = await doFetch(true);
  if (response.status === 401 && token) response = await doFetch(false);

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.message || `Medusa API error: ${response.status}`);
  }
  return response.json();
}
